module.exports = __webpack_public_path__ + "img/aragon.1de768ef.jpg";